import axios from 'axios';
import { FETCHING_TRANSACTION_SUMMARY, FETCH_TRANSACTION_SUMMARY_SUCCESS } from "./TransactionSummaryConstants";

const path = 'utm/v1/transactions/summary';

const fetchingTransactionSummary = () => ({ type: FETCHING_TRANSACTION_SUMMARY });
const fetchTransactionSummarySuccess = transactions => ({ type: FETCH_TRANSACTION_SUMMARY_SUCCESS, transactions });

export const fetchTransactionSummary = () => dispatch => {
  dispatch(fetchingTransactionSummary());
  axios.get(path)
    .then(response => {
      dispatch(fetchTransactionSummarySuccess(response.data.data));
    })
    .catch(error => { throw error; });
};



// WEBPACK FOOTER //
// ./src/redux/transactionSummary/TransactionSummaryActions.js